/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewArrivalStory
 */
export interface NewArrivalStory {
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    hash: string;
    /**
     * 
     * @type {number}
     * @memberof NewArrivalStory
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    statusName: string;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    thumbnailUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    smallThumbnailUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    tinyThumbnailUrl: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewArrivalStory
     */
    tags: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewArrivalStory
     */
    businessCategories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    postedAt: string;
    /**
     * 
     * @type {string}
     * @memberof NewArrivalStory
     */
    companyName: string;
}

export function NewArrivalStoryFromJSON(json: any): NewArrivalStory {
    return NewArrivalStoryFromJSONTyped(json, false);
}

export function NewArrivalStoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewArrivalStory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hash': json['hash'],
        'companyId': json['company_id'],
        'title': json['title'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'status': json['status'],
        'statusName': json['status_name'],
        'thumbnailUrl': json['thumbnail_url'],
        'smallThumbnailUrl': json['small_thumbnail_url'],
        'tinyThumbnailUrl': json['tiny_thumbnail_url'],
        'tags': json['tags'],
        'businessCategories': json['business_categories'],
        'postedAt': json['posted_at'],
        'companyName': json['company_name'],
    };
}

export function NewArrivalStoryToJSON(value?: NewArrivalStory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hash': value.hash,
        'company_id': value.companyId,
        'title': value.title,
        'body': value.body,
        'status': value.status,
        'status_name': value.statusName,
        'thumbnail_url': value.thumbnailUrl,
        'small_thumbnail_url': value.smallThumbnailUrl,
        'tiny_thumbnail_url': value.tinyThumbnailUrl,
        'tags': value.tags,
        'business_categories': value.businessCategories,
        'posted_at': value.postedAt,
        'company_name': value.companyName,
    };
}

